// ————————————————————————————————————————————— LIB. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

import { gsap } from "gsap";

// ———————————————————————————————————————————— UTIL. ————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

// import { lockScroll, unlockScroll } from "../../../../../app/modules/baseAppModules/ScrollLock/ScrollLock";
import { lockScroll, unlockScroll } from "../../../../../app/init/init_pageScrollbar";

// ———————————————————————————————————————————— ASSETS ———————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

const logArgs = { eventName: "stChH_activeGridItem_v2", inline: true, disabled: false };
const msgs = {
  change: (CHANGE) => [`stChH_activeGridItem_v2:`, CHANGE],
};

const config_anim_hide = { y: "100%", duration: 0.525, ease: "power1.inOut" };
const config_anim_show = { y: "0%", duration: 0.525, ease: "power1.inOut" };
const config_anim_hide_nav = { x: "-100%", duration: 0.525, ease: "power1.inOut" };
const config_anim_show_nav = { x: "0%", duration: 0.525, ease: "power1.inOut" };

// —————————————————————————————————————————— HDL. DEF. ——————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //

export default function stChH_activeGridItem(CHANGES) {
  //////////////////////////////////////////// Setup /////////////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  const el_body = document.body;
  const { activeGridItem } = CHANGES;
  const { modals_project, projectsNav, projectLinks } = this.ref;
  this.logger("state-change", msgs.change(activeGridItem), "default", logArgs);

  //////////////////////////////////// State change execution ////////////////////////////////////
  ////////////////////////////////////////////////////////////////////////////////////////////////

  if (activeGridItem && activeGridItem != "null") {
    //////// Project links updt. /////////
    ////////////////////////////////////

    if (projectLinks) projectLinks.forEach((link) => (link.dataset.active = link.dataset.id === activeGridItem ? "true" : "false"));

    //////// Open/Close modals /////////
    ////////////////////////////////////

    // Find the target modal with matching data-id
    const targetModal = modals_project.find((m) => m.dataset.id === activeGridItem);

    if (targetModal) {
      // Hide all other modals first
      modals_project.forEach((m) => {
        if (m !== targetModal && m.dataset.hidden !== "true") {
          gsap.to(m, { ...config_anim_hide, onComplete: () => (m.dataset.hidden = "true") });
        }
      });

      // Show the target modal
      el_body.dataset.hasOpenModal = "true";
      gsap.to(targetModal, {
        ...config_anim_show,
        onComplete: () => {
          targetModal.dataset.hidden = "false";
          lockScroll();
        },
      });

      // Show projects nav
      setTimeout(() => gsap.to(projectsNav, { ...config_anim_show_nav }), 50);
    }
  } else {
    // No active grid item - hide all modals
    modals_project.forEach((m) => {
      if (m.dataset.hidden !== "true") {
        el_body.dataset.hasOpenModal = "false";
        gsap.to(m, {
          ...config_anim_hide,
          onComplete: () => {
            m.dataset.hidden = "true";
            unlockScroll();
          },
        });
      }
    });

    // Hide projects nav
    setTimeout(() => gsap.to(projectsNav, { ...config_anim_hide_nav }), 100);
  }
}

// ———————————————————————————————————————————————————————————————————————————————————————————————— //
// ———————————————————————————————————————————————————————————————————————————————————————————————— //
